"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../../utils");
var _DeviceSelectionControl = _interopRequireDefault(require("./DeviceSelectionControl"));
var _components = require("../../../components");
var _VideoControl = _interopRequireDefault(require("./VideoControl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var VideoControls = function VideoControls(props) {
  var isMaximized = props.isMaximized,
    audioEnabled = props.audioEnabled,
    onFinish = props.onFinish,
    toggleAudio = props.toggleAudio,
    toggleVideo = props.toggleVideo,
    videoEnabled = props.videoEnabled,
    screenSharingInProgress = props.screenSharingInProgress,
    toggleIsScreenShareOn = props.toggleIsScreenShareOn,
    user = props.user,
    devices = props.devices,
    allDevices = props.allDevices,
    setDevices = props.setDevices,
    eventHandler = props.eventHandler,
    visible = props.visible;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    finishCallAllowed = _useState2[0],
    setFinishCallAllowed = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    screenSharingSupported = _useState4[0],
    setScreenSharingSupported = _useState4[1];
  (0, _react.useEffect)(function () {
    window.OT.checkScreenSharingCapability(function (_ref) {
      var supported = _ref.supported;
      setScreenSharingSupported(supported && !(0, _utils.isMobile)());
    });
  }, []);
  var onFinishHandler = function onFinishHandler(e) {
    e.stopPropagation();
    onFinish();
    setFinishCallAllowed(false);
  };
  var isScreenSharingControlAvailable = (0, _utils.isClinician)(user) && screenSharingSupported && isMaximized;
  var isFullView = isMaximized && !(0, _utils.isMobile)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('--tag-video-controls absolute bottom-0 left-0 w-full h-[70px] z-1', 'flex justify-center items-center', 'bg-black text-center px-[20px]', {
      none: !visible,
      'gap-[20px] justify-center': isFullView
    })
  }, /*#__PURE__*/_react.default.createElement(_DeviceSelectionControl.default, {
    type: "audio",
    enabled: audioEnabled,
    selectedDevice: devices.audio,
    devices: allDevices.audio,
    onChangeDevice: function onChangeDevice(device) {
      setDevices(function (d) {
        return _objectSpread(_objectSpread({}, d), {}, {
          audio: device
        });
      });
    },
    toggleEnabled: eventHandler(toggleAudio),
    label: "".concat(audioEnabled ? 'Mute' : 'Unmute', " ").concat(isFullView ? ' audio' : ''),
    selectLabel: "Select a microphone",
    isMaximized: isMaximized
  }), /*#__PURE__*/_react.default.createElement(_DeviceSelectionControl.default, {
    type: "video",
    enabled: videoEnabled,
    selectedDevice: devices.video,
    devices: allDevices.video,
    onChangeDevice: function onChangeDevice(device) {
      setDevices(function (d) {
        return _objectSpread(_objectSpread({}, d), {}, {
          video: device
        });
      });
    },
    toggleEnabled: eventHandler(toggleVideo),
    label: "".concat(videoEnabled ? 'Stop' : 'Start', " ").concat(isFullView ? ' video' : ''),
    selectLabel: "Select a camera",
    isMaximized: isMaximized
  }), isScreenSharingControlAvailable && /*#__PURE__*/_react.default.createElement(_VideoControl.default, {
    label: "Share screen",
    iconType: screenSharingInProgress ? 'screenshare-on' : 'screenshare-off',
    isMaximized: isMaximized,
    onClick: eventHandler(toggleIsScreenShareOn)
  }), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    onClick: eventHandler(onFinishHandler),
    onTouchStart: eventHandler(onFinishHandler),
    disabled: !finishCallAllowed,
    className: "w-[80px] bg-alertred-60 hover:bg-alertred-60"
  }, "End"));
};
VideoControls.propTypes = {
  audioEnabled: _propTypes.default.bool,
  onFinish: _propTypes.default.func,
  toggleAudio: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
  toggleVideo: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
  videoEnabled: _propTypes.default.bool,
  audioDevices: _propTypes.default.arrayOf(_propTypes.default.shape({
    deviceId: _propTypes.default.string.isRequired,
    kind: _propTypes.default.oneOf(['audioInput', 'videoInput']).isRequired,
    label: _propTypes.default.string.isRequired
  })),
  videoDevices: _propTypes.default.arrayOf(_propTypes.default.shape({
    deviceId: _propTypes.default.bool.isRequired,
    kind: _propTypes.default.oneOf(['audioInput', 'videoInput']).isRequired,
    label: _propTypes.default.string.isRequired
  }))
};
var _default = VideoControls;
exports.default = _default;